import { render, staticRenderFns } from "./ProfileInnerHeaderUpper.vue?vue&type=template&id=afcac482&scoped=true&"
import script from "./ProfileInnerHeaderUpper.vue?vue&type=script&lang=ts&"
export * from "./ProfileInnerHeaderUpper.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInnerHeaderUpper.vue?vue&type=style&index=0&id=afcac482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcac482",
  null
  
)

export default component.exports